import React from 'react';
import PropTypes from 'prop-types';
import { Chip } from '@core/Chip';
import { buildGradientStyle } from '@utils/teaserGradient';
import { appChipStyle, appChipSize, appIconsPath } from '@utils/globalConstant';
import './NewsTeaserSmall.scss';

export function NewsTeaserSmall({
  type = 'default',
  className = '',
  hasChip = false,
  chipTitle = '',
  chipTitleColor = '',
  chipIcon = null,
  badgeColor = 'white',
  headline = '',
  hasImage = false,
  imageSrc = '',
  buttonHref = null,
  teaserStyle = 'plain',
  linearGradient = 'leftToRight',
  bgColor1 = '',
  bgColor2 = '',
  teaserTitleColor = 'white'
}) {
  const getBackgroundStyle = () => {
    let styles = {
      minHeight: '160px'
    };

    let gradientStyle = buildGradientStyle(teaserStyle, bgColor1, bgColor2, linearGradient);

    const useGradient = Boolean(gradientStyle);
    if (!useGradient) {
      // handle teaserStyle plain
      gradientStyle = { background: bgColor1 };
    }
    styles = {...styles, ...gradientStyle};

    return styles;
  };

  const getChipStyle = () => {
    if (badgeColor === 'white') {
      return appChipStyle.WHITE;
    }
    // Add other badge color mappings as needed
    if (badgeColor.startsWith('#')) {
      return badgeColor;
    }
    return appChipStyle.WHITE; // Default to white chip
  };

  const content = (
    <div
      className={`news-teaser-small rounded-3 overflow-hidden position-relative ${className}`}
      style={getBackgroundStyle()}>
      <div className="news-teaser-small__content d-flex flex-column justify-content-between p-12 h-100">
        {hasChip && chipTitle && (
          <div>
            <Chip
              chipStyle={getChipStyle()}
              chipSize={appChipSize.SMALL}
              label={chipTitle}
              icon={chipIcon ? appIconsPath[chipIcon] || chipIcon : null}
            />
          </div>
        )}
        {headline && (
          <div
            className="pt-12 ek-h2"
            style={{ color: teaserTitleColor, width: '50%' }}
            dangerouslySetInnerHTML={{ __html: headline }}
          />
        )}
      </div>
      <div
        className="news-teaser-small__image"
        style={hasImage && imageSrc ? { backgroundImage: `url(${imageSrc})` } : {}}
      />
    </div>
  );

  if (buttonHref) {
    return (
      <a href={buttonHref} className="text-decoration-none d-block">
        {content}
      </a>
    );
  }

  return content;
}

NewsTeaserSmall.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
  hasChip: PropTypes.bool,
  chipTitle: PropTypes.string,
  chipTitleColor: PropTypes.string,
  chipIcon: PropTypes.string,
  badgeColor: PropTypes.string,
  headline: PropTypes.string,
  hasImage: PropTypes.bool,
  imageSrc: PropTypes.string,
  buttonHref: PropTypes.string,
  teaserStyle: PropTypes.string,
  linearGradient: PropTypes.string,
  bgColor1: PropTypes.string,
  bgColor2: PropTypes.string,
  teaserTitleColor: PropTypes.string
};

export default NewsTeaserSmall;
